import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';

const TYPES_ENERGIE = [
  { value: 'electrique', label: 'Électrique' },
  { value: 'gaz', label: 'Gaz (GPL)' },
  { value: 'diesel', label: 'Diesel' },
  { value: 'thermique', label: 'Thermique' },
  { value: 'manuel', label: 'Manuel' },
  { value: 'pneumatique', label: 'Pneumatique' }
];

const CONFORMITES = [
  { value: 'CE', label: 'CE' },
  { value: 'non_ce', label: 'Non CE' },
  { value: 'en_cours', label: 'En cours' }
];

const TYPES_CHAINES_SELECT = [
  { value: '4x4_25.4mm', label: '4x4 / 25,4mm (Feuilletée)' },
  { value: '6x4_15.84mm', label: '6x4 / 15,84mm (Feuilletée)' },
  { value: 'simple_pas_standard', label: 'Simple, pas standard' },
  { value: 'double_pas_standard', label: 'Double, pas standard' }
];

// 🔥 Équipements prédéfinis par famille (aligné avec l'app principale)
const EQUIPEMENTS_PAR_FAMILLE = {
  B1: {
    securite: [
      "Limiteur de charge",
      "Arrêt d'urgence",
      "Dispositif anti-collision",
      "Fin de course haut/bas",
      "Protection contre la survitesse",
      "Signalisation sonore",
      "Éclairage de sécurité"
    ],
    complementaires: [
      "Télécommande radio",
      "Pesage intégré",
      "Variateur de vitesse",
      "Boîte à boutons pendante",
      "Cabine de commande",
      "Système anti-balancement"
    ]
  },
  B2: {
    securite: [
      "Limiteur de charge (CMU)",
      "Limiteur de couple",
      "Anémomètre",
      "Arrêt d'urgence",
      "Dispositif anti-collision",
      "Signalisation lumineuse (gyrophare)",
      "Avertisseur sonore",
      "Contrôleur de niveau (nivomètre)"
    ],
    complementaires: [
      "Caméra de surveillance",
      "Télésurveillance",
      "Télécommande radio",
      "Pesage embarqué",
      "Enregistreur de données",
      "Dispositif anti-heurt"
    ]
  },
  B3: {
    securite: [
      "Limiteur de charge",
      "Indicateur de charge (RCI)",
      "Stabilisateurs",
      "Indicateur d'angle",
      "Dispositif anti-collision",
      "Avertisseur sonore de recul",
      "Gyrophare",
      "Arrêt d'urgence"
    ],
    complementaires: [
      "Télécommande radio",
      "Caméra de recul",
      "Flèche télescopique",
      "Rallonges de flèche",
      "Treuil auxiliaire",
      "Crochet à verrouillage automatique"
    ]
  },
  B4: {
    securite: [
      "Dispositifs de verrouillage",
      "Barre de sécurité",
      "Arrêt d'urgence",
      "Dispositif anti-chute",
      "Détecteur de présence",
      "Protection anti-écrasement",
      "Signalisation sonore"
    ],
    complementaires: [
      "Plateau tournant",
      "Crics intégrés",
      "Éclairage de travail",
      "Compresseur d'air",
      "Enrouleur de câble",
      "Rails de levage ajustables"
    ]
  },
  B5: {
    securite: [
      "Avertisseur sonore de recul",
      "Gyrophare",
      "Ceinture de sécurité",
      "Arceau de protection (FOPS/ROPS)",
      "Arrêt d'urgence",
      "Protège-conducteur",
      "Rétroviseurs",
      "Freins de stationnement"
    ],
    complementaires: [
      "Caméra de recul",
      "Fourches réglables",
      "Rallonges de fourches",
      "Positionneur de fourches",
      "Pince à fûts",
      "Bras télescopique",
      "Cabine fermée chauffée",
      "Système de pesage",
      "TDL Tablier à Déplacement Latéral",
      "Ecarteur de fourches"
    ]
  },
  B6: {
    securite: [
      "Détecteur de surcharge",
      "Dispositif anti-basculement",
      "Arrêt d'urgence au sol",
      "Arrêt d'urgence en nacelle",
      "Stabilisateurs",
      "Détecteur d'inclinaison",
      "Avertisseur sonore",
      "Gyrophare"
    ],
    complementaires: [
      "Commande au sol",
      "Plateforme tournante",
      "Extension de plateforme",
      "Prise électrique 230V",
      "Porte-outils",
      "Système anti-collision",
      "Caméra embarquée"
    ]
  },
  B7: {
    securite: [
      "Dispositif anti-chute",
      "Arrêt d'urgence",
      "Soupape de sécurité",
      "Barrières de protection",
      "Chaînes de sécurité",
      "Protection anti-écrasement",
      "Signalisation sonore"
    ],
    complementaires: [
      "Commande à distance",
      "Plateau tournant",
      "Rouleaux de translation",
      "Bavettes latérales",
      "Béquilles de stabilisation",
      "Rampe d'accès repliable"
    ]
  },
  B8: {
    securite: [
      "Limiteur de charge",
      "Dispositif anti-chute",
      "Arrêt d'urgence",
      "Fin de course haut/bas",
      "Barrières de protection",
      "Signalisation sonore",
      "Éclairage de sécurité"
    ],
    complementaires: [
      "Treuil de levage",
      "Cabine fermée",
      "Commande à distance",
      "Dispositif de freinage automatique",
      "Portes palières",
      "Interphone"
    ]
  },
  B9: {
    securite: [
      "Limiteur de charge",
      "Arrêt d'urgence",
      "Dispositif anti-collision",
      "Signalisation sonore",
      "Barrières de protection"
    ],
    complementaires: [
      "Télécommande radio",
      "Palan électrique",
      "Éclairage de travail",
      "Roues de déplacement",
      "Système de freinage"
    ]
  },
  B10: {
    securite: [
      "Dispositif anti-retour",
      "Cliquet de sécurité",
      "Chaînes de sécurité",
      "Protection anti-pincement",
      "Marquage de charge visible"
    ],
    complementaires: [
      "Manivelle démultipliée",
      "Crochet à linguet",
      "Rallonges de chaîne",
      "Support de fixation",
      "Système de freinage manuel"
    ]
  },
  B11: {
    securite: [
      "Arceau ROPS/FOPS",
      "Ceinture de sécurité",
      "Avertisseur sonore de recul",
      "Gyrophare",
      "Rétroviseurs",
      "Arrêt d'urgence",
      "Protections machines"
    ],
    complementaires: [
      "Cabine climatisée",
      "Caméra de recul",
      "Éclairage de travail",
      "Lames/godets interchangeables",
      "GPS/guidage automatique",
      "Marteau piqueur hydraulique"
    ]
  },
  C1: {
    securite: [
      "Marquage CMU visible",
      "Certification de conformité",
      "Dispositif anti-décrochage",
      "Linguet de sécurité",
      "Protection anti-usure"
    ],
    complementaires: [
      "Manille de connexion",
      "Anneaux de levage",
      "Protections d'angle",
      "Dispositif de raccourcissement",
      "Étiquette d'identification RFID"
    ]
  },
  D1: {
    securite: [
      "Garde-corps périphériques",
      "Plinthes de sécurité",
      "Ancrages conformes",
      "Échelle d'accès sécurisée",
      "Stabilisateurs",
      "Dispositif anti-basculement"
    ],
    complementaires: [
      "Plateforme de travail",
      "Trappe d'accès",
      "Roues de déplacement",
      "Freins de blocage",
      "Potence de levage",
      "Filet de protection"
    ]
  }
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#92400e',
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  formGroup: {
    marginBottom: '16px'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%',
    padding: '12px 16px',
    fontSize: '16px',
    border: '2px solid #e5e7eb',
    borderRadius: '12px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  checkboxGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '12px',
    background: '#f9fafb',
    borderRadius: '12px'
  },
  checkboxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 12px',
    background: 'white',
    borderRadius: '8px',
    border: '2px solid #e5e7eb',
    cursor: 'pointer',
    fontSize: '13px'
  },
  checkboxItemActive: {
    background: '#fef3c7',
    borderColor: '#f59e0b'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  badge: {
    padding: '8px 12px',
    background: '#fef3c7',
    color: '#92400e',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    marginBottom: '16px'
  },
  modeleSelector: {
    marginBottom: '16px',
    padding: '12px',
    background: '#eff6ff',
    border: '2px solid #3b82f6',
    borderRadius: '12px'
  },
  modeleSelectorTitle: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1e40af',
    marginBottom: '8px'
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#374151',
    marginBottom: '12px',
    marginTop: '16px'
  }
};

function Etape2CaracteristiquesMobile({ mission, onBack, onSave, familleCode }) {
  const [data, setData] = useState({
    marque: '',
    type: '',
    annee: '',
    numero_serie: '',
    numero_parc: '',
    conformite: 'CE',
    capacite_nominale: '',
    hauteur_levee: '',
    type_energie: '',
    type_alimentation: '',
    types_mat: [],
    types_chaines: [],
    type_chaines_select: '',
    type_chaines_custom: '',
    cmu: '',
    cmu_max: '',
    portee: '',
    portee_max: '',
    hauteur_crochet: '',
    type_montage: '',
    capacite_levage: '',
    longueur_fleche: '',
    type_fleche: '',
    type_stabilisation: '',
    capacite_max: '',
    type_pont: '',
    hauteur_travail: '',
    capacite_plateforme: '',
    portee_horizontale: '',
    type_pemp: '',
    course_levee: '',
    dimensions_plateforme: '',
    nombre_brins: '',
    longueur: '',
    materiau: '',
    capacite: '',
    caracteristiques: '',
    localisation: '',
    utilisateur: '',
    compteur: '',
    compteur_unite: 'heures',
    observations: '',
    technologie_mecanisme: '',
    suspentes_csv: '',
    support_charge: '',
    equipements_csv: '',
    equipements_securite: [],
    equipements_complementaires: [],
    modele_appareil_id: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [currentFamille, setCurrentFamille] = useState(familleCode || '');
  const [modeles, setModeles] = useState([]);
  const [showCustomChaines, setShowCustomChaines] = useState(false);
  const [customEquipementSecurite, setCustomEquipementSecurite] = useState('');
  const [customEquipementComplementaire, setCustomEquipementComplementaire] = useState('');
  const [selectedMarque, setSelectedMarque] = useState('');

  useEffect(() => {
    loadData();
  }, [mission.id]);

  useEffect(() => {
    if (currentFamille) {
      loadModeles(currentFamille);
    }
  }, [currentFamille]);

  useEffect(() => {
    setSelectedMarque('');
  }, [modeles]);

  const loadData = async () => {
    setLoading(true);
    try {
      // Charger famille depuis étape 1
      const etape1Data = await inspectionStorage.getStep(mission.id, 'etape_1_infos_generales_levage');
      if (etape1Data?.famille_machine_code) {
        setCurrentFamille(etape1Data.famille_machine_code);
        
        // 🔥 Charger modèles de cette famille
        await loadModeles(etape1Data.famille_machine_code);
      }

      // Si machine sélectionnée en étape 1, pré-remplir
      if (etape1Data?.machine_selectionnee_id) {
        setData(prev => ({
          ...prev,
          marque: etape1Data.machine_marque || '',
          type: etape1Data.machine_type || '',
          numero_serie: etape1Data.machine_numero_serie || '',
          numero_parc: etape1Data.machine_numero_parc || ''
        }));
      }

      // Charger données étape 2
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_2_caracteristiques_techniques_levage');
      if (savedData) {
        setData(prev => ({ ...prev, ...savedData }));
        if (savedData.famille_machine_code) {
          setCurrentFamille(savedData.famille_machine_code);
          await loadModeles(savedData.famille_machine_code);
        }
        
        // Si type chaînes custom, afficher le champ
        if (savedData.type_chaines_select && !TYPES_CHAINES_SELECT.find(t => t.value === savedData.type_chaines_select)) {
          setShowCustomChaines(true);
        }
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const getModeleFamilleCode = (modele) =>
    modele.famille_code ||
    modele.familleCode ||
    modele.famille_machine_code ||
    modele.code_annexe ||
    modele.famille?.code_annexe ||
    modele.famille?.code ||
    '';

  const getModeleLabel = (modele) =>
    modele.type_modele ||
    modele.designation ||
    modele.reference ||
    '';

  // 🔥 Charger modèles depuis cache
  const loadModeles = async (familleCode) => {
    try {
      if (!familleCode) {
        setModeles([]);
        return;
      }

      const cachedModeles = await inspectionStorage.get(`modeles_famille_${familleCode}`);
      if (Array.isArray(cachedModeles) && cachedModeles.length > 0) {
        setModeles(cachedModeles);
        console.log(`✅ ${cachedModeles.length} modèles chargés depuis le cache`);
        return;
      }

      const cachedAll = await inspectionStorage.get('modeles_appareils_all');
      if (Array.isArray(cachedAll) && cachedAll.length > 0) {
        const byFamille = cachedAll.filter((modele) => getModeleFamilleCode(modele) === familleCode);
        const toUse = byFamille.length > 0 ? byFamille : cachedAll;
        setModeles(toUse);
        if (byFamille.length > 0) {
          await inspectionStorage.set(`modeles_famille_${familleCode}`, byFamille);
        }
        console.log(`✅ ${toUse.length} modèles chargés depuis le cache global`);
        return;
      }

      console.log('⚠️ Aucun modèle en cache, chargement API...');
      const apiResult = await apiService.getModelesAppareils();
      if (apiResult.success && Array.isArray(apiResult.modeles) && apiResult.modeles.length > 0) {
        await inspectionStorage.set('modeles_appareils_all', apiResult.modeles);
        const modelesByFamily = apiResult.modeles.reduce((acc, modele) => {
          const code = getModeleFamilleCode(modele);
          if (!code) return acc;
          if (!acc[code]) acc[code] = [];
          acc[code].push(modele);
          return acc;
        }, {});
        const byFamille = modelesByFamily[familleCode] || [];
        const toUse = byFamille.length > 0 ? byFamille : apiResult.modeles;
        setModeles(toUse);
        if (byFamille.length > 0) {
          await inspectionStorage.set(`modeles_famille_${familleCode}`, byFamille);
        }
      } else {
        setModeles([]);
      }
    } catch (error) {
      console.error('❌ Erreur chargement modèles:', error);
      setModeles([]);
    }
  };

  // 🔥 Charger données d'un modèle
  const handleModeleChange = (modeleId) => {
    const modele = modeles.find(m => m.id === modeleId);
    
    if (modele) {
      const resolvedType = getModeleLabel(modele) || '';
      const resolvedMarque = modele.marque || selectedMarque || '';
      setData(prev => ({
        ...prev,
        modele_appareil_id: modele.id || '',
        marque: resolvedMarque || prev.marque,
        type: resolvedType || prev.type,
        type_modele: resolvedType || prev.type_modele || '',
        conformite: modele.conformite || prev.conformite,
        ...(modele.caracteristiques_techniques || {}),
        equipements_securite: modele.equipements_securite || [],
        equipements_complementaires: modele.equipements_complementaires || [],
        // Ne pas écraser les champs instance-specific
        annee: prev.annee,
        numero_serie: prev.numero_serie,
        numero_parc: prev.numero_parc,
        localisation: prev.localisation,
        utilisateur: prev.utilisateur,
        compteur: prev.compteur,
        compteur_unite: prev.compteur_unite
      }));
    } else {
      setData(prev => ({ ...prev, modele_appareil_id: '' }));
    }
  };

  const getMarques = () => {
    const unique = [...new Set(modeles.map((m) => (m.marque || '').trim()).filter(Boolean))];
    return unique.sort((a, b) => a.localeCompare(b, 'fr', { sensitivity: 'base' }));
  };

  const getModelesForMarque = () => {
    if (!selectedMarque) return [];
    return modeles.filter((m) => (m.marque || '').trim() === selectedMarque);
  };

  const handleChange = (field, value) => {
    setData(prev => ({ ...prev, [field]: value }));
  };

  const toggleArrayItem = (field, item) => {
    const current = data[field] || [];
    const updated = current.includes(item)
      ? current.filter(i => i !== item)
      : [...current, item];
    handleChange(field, updated);
  };

  const handleTypeChainesSelectChange = (value) => {
    if (value === 'custom') {
      setShowCustomChaines(true);
      handleChange('type_chaines_select', '');
    } else {
      setShowCustomChaines(false);
      handleChange('type_chaines_select', value);
      handleChange('type_chaines_custom', '');
    }
  };

  const saveCustomChaines = () => {
    if (data.type_chaines_custom.trim()) {
      handleChange('type_chaines_select', data.type_chaines_custom.trim());
      setShowCustomChaines(false);
    } else {
      alert('⚠️ Veuillez saisir un type de chaînes');
    }
  };

  const addCustomEquipement = (type) => {
    const value = (type === 'securite' ? customEquipementSecurite : customEquipementComplementaire).trim();
    if (!value) return;
    const field = type === 'securite' ? 'equipements_securite' : 'equipements_complementaires';
    const current = data[field] || [];
    if (!current.includes(value)) {
      handleChange(field, [...current, value]);
    }
    if (type === 'securite') {
      setCustomEquipementSecurite('');
    } else {
      setCustomEquipementComplementaire('');
    }
  };

  const renderSpecificFields = () => {
    if (currentFamille === 'B5') {
      return (
        <>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Capacité nominale (kg) *</label>
              <input
                type="number"
                style={styles.input}
                value={data.capacite_nominale}
                onChange={(e) => handleChange('capacite_nominale', e.target.value)}
                placeholder="Ex: 1500"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Hauteur de levée (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.hauteur_levee}
                onChange={(e) => handleChange('hauteur_levee', e.target.value)}
                placeholder="Ex: 4.5"
              />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type d'énergie</label>
            <select
              style={styles.select}
              value={data.type_energie}
              onChange={(e) => handleChange('type_energie', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              {TYPES_ENERGIE.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de mât</label>
            <div style={styles.checkboxGroup}>
              {['simple', 'double', 'triple'].map(mat => (
                <div
                  key={mat}
                  style={{
                    ...styles.checkboxItem,
                    ...(data.types_mat?.includes(mat) ? styles.checkboxItemActive : {})
                  }}
                  onClick={() => toggleArrayItem('types_mat', mat)}
                >
                  <span>{mat.charAt(0).toUpperCase() + mat.slice(1)}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de chaînes</label>
            <div style={styles.checkboxGroup}>
              {[
                { value: 'mailles_jointives', label: 'Mailles jointives' },
                { value: 'rouleaux', label: 'À rouleaux' }
              ].map(ch => (
                <div
                  key={ch.value}
                  style={{
                    ...styles.checkboxItem,
                    ...(data.types_chaines?.includes(ch.value) ? styles.checkboxItemActive : {})
                  }}
                  onClick={() => toggleArrayItem('types_chaines', ch.value)}
                >
                  <span>{ch.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de chaînes (description)</label>
            {!showCustomChaines ? (
              <select
                style={styles.select}
                value={data.type_chaines_select}
                onChange={(e) => handleTypeChainesSelectChange(e.target.value)}
              >
                <option value="">Sélectionner...</option>
                {TYPES_CHAINES_SELECT.map(t => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
                <option value="custom">✏️ Autre (texte libre)</option>
              </select>
            ) : (
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  style={{ ...styles.input, flex: 1 }}
                  value={data.type_chaines_custom}
                  onChange={(e) => handleChange('type_chaines_custom', e.target.value)}
                  placeholder="Ex: 8x6 / 20mm..."
                />
                <button
                  onClick={saveCustomChaines}
                  style={{
                    padding: '12px 16px',
                    background: '#3b82f6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600'
                  }}
                >
                  ✓
                </button>
                <button
                  onClick={() => {
                    setShowCustomChaines(false);
                    handleChange('type_chaines_custom', '');
                    handleChange('type_chaines_select', '');
                  }}
                  style={{
                    padding: '12px 16px',
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: '600'
                  }}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </>
      );
    }

    if (currentFamille === 'B1') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>CMU - Charge Max d'Utilisation (kg) *</label>
            <input
              type="number"
              style={styles.input}
              value={data.cmu}
              onChange={(e) => handleChange('cmu', e.target.value)}
              placeholder="Ex: 2000"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Hauteur de levée (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.hauteur_levee}
                onChange={(e) => handleChange('hauteur_levee', e.target.value)}
                placeholder="Ex: 6.0"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Portée (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.portee}
                onChange={(e) => handleChange('portee', e.target.value)}
                placeholder="Ex: 10.5"
              />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type d'alimentation</label>
            <select
              style={styles.select}
              value={data.type_alimentation}
              onChange={(e) => handleChange('type_alimentation', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              <option value="electrique">Électrique</option>
              <option value="pneumatique">Pneumatique</option>
              <option value="manuel">Manuel</option>
            </select>
          </div>
        </>
      );
    }

    if (currentFamille === 'B2') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>CMU maximale (kg) *</label>
            <input
              type="number"
              style={styles.input}
              value={data.cmu_max}
              onChange={(e) => handleChange('cmu_max', e.target.value)}
              placeholder="Ex: 8000"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Portée maximale (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.portee_max}
                onChange={(e) => handleChange('portee_max', e.target.value)}
                placeholder="Ex: 50.0"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Hauteur sous crochet (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.hauteur_crochet}
                onChange={(e) => handleChange('hauteur_crochet', e.target.value)}
                placeholder="Ex: 40.0"
              />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de montage</label>
            <select
              style={styles.select}
              value={data.type_montage}
              onChange={(e) => handleChange('type_montage', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              <option value="gme">Par élément (GME)</option>
              <option value="gma">Automatisé (GMA)</option>
            </select>
          </div>
        </>
      );
    }

    if (currentFamille === 'B3') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>Capacité de levage (tonnes) *</label>
            <input
              type="number"
              step="0.1"
              style={styles.input}
              value={data.capacite_levage}
              onChange={(e) => handleChange('capacite_levage', e.target.value)}
              placeholder="Ex: 25.0"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Longueur de flèche (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.longueur_fleche}
                onChange={(e) => handleChange('longueur_fleche', e.target.value)}
                placeholder="Ex: 30.0"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Type de flèche</label>
              <select
                style={styles.select}
                value={data.type_fleche}
                onChange={(e) => handleChange('type_fleche', e.target.value)}
              >
                <option value="">Sélectionner...</option>
                <option value="telescopique">Télescopique</option>
                <option value="treillis">Treillis</option>
              </select>
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de stabilisation</label>
            <select
              style={styles.select}
              value={data.type_stabilisation}
              onChange={(e) => handleChange('type_stabilisation', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              <option value="stabilisateurs">Stabilisateurs</option>
              <option value="pneumatiques">Pneumatiques</option>
              <option value="chenilles">Chenilles</option>
            </select>
          </div>
        </>
      );
    }

    if (currentFamille === 'B4') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>Capacité maximale (kg) *</label>
            <input
              type="number"
              style={styles.input}
              value={data.capacite_max}
              onChange={(e) => handleChange('capacite_max', e.target.value)}
              placeholder="Ex: 3500"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Hauteur de levée (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.hauteur_levee}
                onChange={(e) => handleChange('hauteur_levee', e.target.value)}
                placeholder="Ex: 2.0"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Type de pont</label>
              <select
                style={styles.select}
                value={data.type_pont}
                onChange={(e) => handleChange('type_pont', e.target.value)}
              >
                <option value="">Sélectionner...</option>
                <option value="2_colonnes">2 colonnes</option>
                <option value="4_colonnes">4 colonnes</option>
                <option value="ciseaux">Ciseaux</option>
                <option value="mobile">Mobile</option>
              </select>
            </div>
          </div>
        </>
      );
    }

    if (currentFamille === 'B6') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>Hauteur de travail (m) *</label>
            <input
              type="number"
              step="0.1"
              style={styles.input}
              value={data.hauteur_travail}
              onChange={(e) => handleChange('hauteur_travail', e.target.value)}
              placeholder="Ex: 12.0"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Capacité plate-forme (kg)</label>
              <input
                type="number"
                style={styles.input}
                value={data.capacite_plateforme}
                onChange={(e) => handleChange('capacite_plateforme', e.target.value)}
                placeholder="Ex: 200"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Portée horizontale (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.portee_horizontale}
                onChange={(e) => handleChange('portee_horizontale', e.target.value)}
                placeholder="Ex: 8.0"
              />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Type de PEMP</label>
            <select
              style={styles.select}
              value={data.type_pemp}
              onChange={(e) => handleChange('type_pemp', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              <option value="bras_articule">Bras articulé</option>
              <option value="ciseaux">Ciseaux</option>
              <option value="mat_vertical">Mât vertical</option>
              <option value="sur_camion">Sur camion</option>
            </select>
          </div>
        </>
      );
    }

    if (currentFamille === 'B7') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>Capacité maximale (kg) *</label>
            <input
              type="number"
              style={styles.input}
              value={data.capacite_max}
              onChange={(e) => handleChange('capacite_max', e.target.value)}
              placeholder="Ex: 1000"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Course de levée (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.course_levee}
                onChange={(e) => handleChange('course_levee', e.target.value)}
                placeholder="Ex: 1.5"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Dimensions plate-forme (L x l en m)</label>
              <input
                style={styles.input}
                value={data.dimensions_plateforme}
                onChange={(e) => handleChange('dimensions_plateforme', e.target.value)}
                placeholder="Ex: 2.0 x 1.0"
              />
            </div>
          </div>
        </>
      );
    }

    if (currentFamille === 'C1') {
      return (
        <>
          <div style={styles.formGroup}>
            <label style={styles.label}>CMU (kg) *</label>
            <input
              type="number"
              style={styles.input}
              value={data.cmu}
              onChange={(e) => handleChange('cmu', e.target.value)}
              placeholder="Ex: 500"
            />
          </div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Nombre de brins</label>
              <input
                type="number"
                style={styles.input}
                value={data.nombre_brins}
                onChange={(e) => handleChange('nombre_brins', e.target.value)}
                placeholder="Ex: 2"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Longueur (m)</label>
              <input
                type="number"
                step="0.1"
                style={styles.input}
                value={data.longueur}
                onChange={(e) => handleChange('longueur', e.target.value)}
                placeholder="Ex: 3.0"
              />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Matériau</label>
            <select
              style={styles.select}
              value={data.materiau}
              onChange={(e) => handleChange('materiau', e.target.value)}
            >
              <option value="">Sélectionner...</option>
              <option value="cable_acier">Câble acier</option>
              <option value="chaine_grade8">Chaîne grade 8</option>
              <option value="textile">Textile (sangle)</option>
              <option value="autre">Autre</option>
            </select>
          </div>
        </>
      );
    }

    return (
      <>
        <div style={styles.formGroup}>
          <label style={styles.label}>Capacité / CMU (kg)</label>
          <input
            type="number"
            style={styles.input}
            value={data.capacite}
            onChange={(e) => handleChange('capacite', e.target.value)}
            placeholder="Ex: 1000"
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.label}>Caractéristiques spécifiques</label>
          <textarea
            style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }}
            value={data.caracteristiques}
            onChange={(e) => handleChange('caracteristiques', e.target.value)}
            placeholder="Caractéristiques techniques spécifiques..."
          />
        </div>
      </>
    );
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_2_caracteristiques_techniques_levage', data);
      console.log('✅ Étape 2 levage sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  const equipements = EQUIPEMENTS_PAR_FAMILLE[currentFamille] || { securite: [], complementaires: [] };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Caractéristiques</h1>
        <button style={{ ...styles.backBtn }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Badge famille */}
        {currentFamille && (
          <div style={styles.badge}>
            🏗️ Annexe {currentFamille}
          </div>
        )}

        {/* 🔥 Sélection modèle depuis bibliothèque */}
        {modeles.length > 0 && (
          <div style={styles.modeleSelector}>
            <div style={styles.modeleSelectorTitle}>📚 Modèles disponibles</div>
            {/* Marque */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Marque</label>
              <select
                style={styles.select}
                value={selectedMarque}
                onChange={(e) => setSelectedMarque(e.target.value)}
              >
                <option value="">Sélectionner une marque...</option>
                {getMarques().map((marque) => (
                  <option key={marque} value={marque}>{marque}</option>
                ))}
              </select>
            </div>

            {/* Modèle */}
            {selectedMarque && (
              <div style={styles.formGroup}>
                <label style={styles.label}>Modèle</label>
                <select
                  style={styles.select}
                  onChange={(e) => handleModeleChange(e.target.value)}
                >
                  <option value="">Saisie manuelle</option>
                  {getModelesForMarque().map(m => (
                    <option key={m.id} value={m.id}>
                      {getModeleLabel(m) || m.id}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
        )}

        {/* Identification */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>🔖 Identification</h3>
          
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Marque *</label>
              <input
                type="text"
                style={styles.input}
                value={data.marque}
                onChange={(e) => handleChange('marque', e.target.value)}
                placeholder="Ex: Toyota"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Type/Modèle *</label>
              <input
                type="text"
                style={styles.input}
                value={data.type}
                onChange={(e) => handleChange('type', e.target.value)}
                placeholder="Ex: 8FGF25"
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>N° série *</label>
              <input
                type="text"
                style={styles.input}
                value={data.numero_serie}
                onChange={(e) => handleChange('numero_serie', e.target.value)}
                placeholder="N° série"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Année</label>
              <input
                type="text"
                style={styles.input}
                value={data.annee}
                onChange={(e) => handleChange('annee', e.target.value)}
                placeholder="2020"
              />
            </div>
          </div>

          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>N° parc</label>
              <input
                type="text"
                style={styles.input}
                value={data.numero_parc}
                onChange={(e) => handleChange('numero_parc', e.target.value)}
                placeholder="Identifiant interne"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Conformité</label>
              <select
                style={styles.select}
                value={data.conformite}
                onChange={(e) => handleChange('conformite', e.target.value)}
              >
                {CONFORMITES.map(c => (
                  <option key={c.value} value={c.value}>{c.label}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Caractéristiques techniques */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>⚙️ Caractéristiques techniques</h3>
          {renderSpecificFields()}

          {/* 🔥 Technologie mécanisme */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Technologie du mécanisme de levage</label>
            <input
              type="text"
              style={styles.input}
              value={data.technologie_mecanisme}
              onChange={(e) => handleChange('technologie_mecanisme', e.target.value)}
              placeholder="Ex: Hydraulique, Électrique..."
            />
          </div>

          {/* 🔥 Support de charge */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Support de charge</label>
            <input
              type="text"
              style={styles.input}
              value={data.support_charge}
              onChange={(e) => handleChange('support_charge', e.target.value)}
              placeholder="Ex: Fourches, Crochet..."
            />
          </div>

          {/* 🔥 Suspentes et vérins */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Suspentes et vérins</label>
            <textarea
              style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }}
              value={data.suspentes_csv}
              onChange={(e) => handleChange('suspentes_csv', e.target.value)}
              placeholder="Ex: Mat triple, 1 + 2 vérins de levage..."
            />
          </div>

          {/* 🔥 Équipements divers */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Équipements divers</label>
            <textarea
              style={{ ...styles.input, minHeight: '80px', resize: 'vertical' }}
              value={data.equipements_csv}
              onChange={(e) => handleChange('equipements_csv', e.target.value)}
              placeholder="Ex: Treuil auxiliaire, télécommande..."
            />
          </div>
        </div>

        {/* 🔥 Équipements de sécurité */}
        {equipements.securite.length > 0 && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>🛡️ Équipements de sécurité</h3>
            <div style={styles.checkboxGroup}>
              {equipements.securite.map((eq, idx) => (
                <div
                  key={idx}
                  style={{
                    ...styles.checkboxItem,
                    ...(data.equipements_securite?.includes(eq) ? styles.checkboxItemActive : {})
                  }}
                  onClick={() => toggleArrayItem('equipements_securite', eq)}
                >
                  <span>{eq}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <input
                type="text"
                style={{ ...styles.input, flex: 1 }}
                value={customEquipementSecurite}
                onChange={(e) => setCustomEquipementSecurite(e.target.value)}
                placeholder="Ajouter un équipement sécurité..."
              />
              <button
                onClick={() => addCustomEquipement('securite')}
                style={{ ...styles.backBtn, background: '#f59e0b' }}
              >
                +
              </button>
            </div>
          </div>
        )}

        {/* 🔥 Équipements complémentaires */}
        {equipements.complementaires.length > 0 && (
          <div style={styles.card}>
            <h3 style={styles.cardTitle}>🔧 Équipements complémentaires</h3>
            <div style={styles.checkboxGroup}>
              {equipements.complementaires.map((eq, idx) => (
                <div
                  key={idx}
                  style={{
                    ...styles.checkboxItem,
                    ...(data.equipements_complementaires?.includes(eq) ? styles.checkboxItemActive : {})
                  }}
                  onClick={() => toggleArrayItem('equipements_complementaires', eq)}
                >
                  <span>{eq}</span>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
              <input
                type="text"
                style={{ ...styles.input, flex: 1 }}
                value={customEquipementComplementaire}
                onChange={(e) => setCustomEquipementComplementaire(e.target.value)}
                placeholder="Ajouter un équipement complémentaire..."
              />
              <button
                onClick={() => addCustomEquipement('complementaires')}
                style={{ ...styles.backBtn, background: '#f59e0b' }}
              >
                +
              </button>
            </div>
          </div>
        )}

        {/* Localisation et compteur */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📍 Localisation & Compteur</h3>

          <div style={styles.formGroup}>
            <label style={styles.label}>Localisation</label>
            <input
              type="text"
              style={styles.input}
              value={data.localisation}
              onChange={(e) => handleChange('localisation', e.target.value)}
              placeholder="Atelier principal"
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Utilisateur / Service</label>
            <input
              type="text"
              style={styles.input}
              value={data.utilisateur}
              onChange={(e) => handleChange('utilisateur', e.target.value)}
              placeholder="Service logistique"
            />
          </div>

          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Compteur</label>
              <input
                type="number"
                style={styles.input}
                value={data.compteur}
                onChange={(e) => handleChange('compteur', e.target.value)}
                placeholder="1250"
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Unité</label>
              <select
                style={styles.select}
                value={data.compteur_unite}
                onChange={(e) => handleChange('compteur_unite', e.target.value)}
              >
                <option value="heures">Heures</option>
                <option value="cycles">Cycles</option>
                <option value="kilometres">Kilomètres</option>
                <option value="manoeuvres">Manœuvres</option>
              </select>
            </div>
          </div>
        </div>

        {/* Observations */}
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📝 Observations</h3>
          <textarea
            style={{ ...styles.input, minHeight: '100px', resize: 'vertical' }}
            value={data.observations}
            onChange={(e) => handleChange('observations', e.target.value)}
            placeholder="Remarques particulières..."
          />
        </div>
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape2CaracteristiquesMobile;